const security = {
    page_title: 'Sicherheit',
    title: 'Sicherheit',
    subtitle: 'Erweiterte Schutzmaßnahmen gegen komplexe Angriffe konfigurieren.',
    tabs: {
        captcha: 'CAPTCHA',
        password_policy: 'Passwortpolitik',
        blocklist: 'Blockliste',
        general: 'Allgemein',
    },
    bot_protection: {
        custom_ui_captcha_notice: 'Sie verwenden eine eigene Oberfläche. CAPTCHA erfordert dort zusätzliche Konfiguration. <a>Einrichtungsanleitung anzeigen</a>.',
        title: 'Bot-Schutz',
        description: 'Aktivieren Sie CAPTCHA für die Anmeldung, Anmeldung und Passwortwiederherstellung, um automatisierte Bedrohungen zu blockieren.',
        captcha: {
            title: 'CAPTCHA',
            placeholder: 'Wählen Sie einen CAPTCHA-Anbieter aus und richten Sie die Integration ein.',
            add: 'CAPTCHA hinzufügen',
        },
        settings: 'Einstellungen',
        enable_captcha: 'CAPTCHA aktivieren',
        enable_captcha_description: 'Aktivieren Sie die CAPTCHA-Verifizierung für Anmelde-, Anmelde- und Passwortwiederherstellungsabläufe.',
    },
    create_captcha: {
        setup_captcha: 'CAPTCHA einrichten',
    },
    captcha_providers: {
        recaptcha_enterprise: {
            name: 'reCAPTCHA Enterprise',
            description: 'Googles unternehmensgerechte CAPTCHA-Lösung, die fortschrittliche Bedrohungserkennung und detaillierte Sicherheitsanalysen bietet, um Ihre Website vor betrügerischen Aktivitäten zu schützen.',
        },
        turnstile: {
            name: 'Cloudflare Turnstile',
            description: 'Cloudflares intelligente CAPTCHA-Alternative, die einen nicht aufdringlichen Bot-Schutz bietet und gleichzeitig eine nahtlose Benutzererfahrung ohne visuelle Rätsel gewährleistet.',
        },
        aliyun: {
            name: 'Alibaba Cloud Captcha 2.0',
            description: 'Risikobasierter CAPTCHA-Dienst von Alibaba Cloud für Web- und H5-Anwendungen mit serverseitiger Prüfung und regionalen Endpunkten.',
        },
    },
    captcha_details: {
        aliyun_region: 'Dienstregion',
        aliyun_region_china: 'Festlandchina (Endpunkt Shanghai)',
        aliyun_region_singapore: 'International (Endpunkt Singapur)',
        aliyun_prefix: 'Prefix',
        aliyun_scene_id: 'Scene ID',
        aliyun_access_key_id: 'AccessKey ID',
        aliyun_access_key_secret: 'AccessKey Secret',
        back_to_security: 'Zurück zur Sicherheit',
        page_title: 'CAPTCHA-Details',
        check_readme: 'README überprüfen',
        options_change_captcha: 'CAPTCHA-Anbieter ändern',
        connection: 'Verbindung',
        description: 'Konfigurieren Sie Ihre CAPTCHA-Verbindungen.',
        site_key: 'Seitenschlüssel',
        secret_key: 'Geheimschlüssel',
        project_id: 'Projekt-ID',
        domain: 'Domain (optional)',
        domain_placeholder: 'www.google.com (Standard) oder recaptcha.net',
        recaptcha_key_id: 'reCAPTCHA-Schlüssel-ID',
        recaptcha_api_key: 'API-Schlüssel des Projekts',
        deletion_description: 'Sind Sie sicher, dass Sie diesen CAPTCHA-Anbieter löschen möchten?',
        captcha_deleted: 'CAPTCHA-Anbieter erfolgreich gelöscht',
        setup_captcha: 'CAPTCHA einrichten',
        mode: 'Überprüfungsmodus',
        mode_invisible: 'Unsichtbar',
        mode_checkbox: 'Kontrollkästchen',
        mode_notice: 'Der Überprüfungsmodus wird in Ihren reCAPTCHA-Schlüsseleinstellungen in der Google Cloud Console definiert. Zum Ändern des Modus hier ist ein passender Schlüsseltyp erforderlich.',
    },
    password_policy: {
        password_requirements: 'Passwortanforderungen',
        password_requirements_description: 'Verbessern Sie die Passwortanforderungen, um sich gegen Anmeldeübergriffe und Angriffe mit schwachen Passwörtern zu verteidigen.',
        minimum_length: 'Mindestlänge',
        minimum_length_description: 'NIST schlägt vor, <a>mindestens 8 Zeichen</a> für Webprodukte zu verwenden.',
        minimum_length_error: 'Die Mindestlänge muss zwischen {{min}} und {{max}} (einschließlich) sein.',
        minimum_required_char_types: 'Mindestanzahl erforderlicher Zeichentypen',
        minimum_required_char_types_description: 'Zeichentypen: Großbuchstaben (A-Z), Kleinbuchstaben (a-z), Zahlen (0-9) und Sonderzeichen ({{symbols}}).',
        password_rejection: 'Passwortablehnung',
        compromised_passwords: 'Abgelehnte Passwörter',
        breached_passwords: 'Verletzte Passwörter',
        breached_passwords_description: 'Ablehnung von zuvor in den Verletzungsdatenbanken gefundenen Passwörtern.',
        restricted_phrases: 'Einschränkung niedrigsicherer Phrasen',
        restricted_phrases_tooltip: 'Ihr Passwort sollte diese Phrasen vermeiden, es sei denn, Sie kombinieren sie mit 3 oder mehr zusätzlichen Zeichen.',
        repetitive_or_sequential_characters: 'Wiederholte oder aufeinanderfolgende Zeichen',
        repetitive_or_sequential_characters_description: 'Zum Beispiel "AAAA", "1234" und "abcd".',
        user_information: 'Benutzerinformationen',
        user_information_description: 'Zum Beispiel E-Mail-Adresse, Telefonnummer, Benutzername, etc.',
        custom_words: 'Benutzerdefinierte Wörter',
        custom_words_description: 'Personalisierte kontextspezifische Wörter, Groß-/Kleinschreibung wird nicht beachtet, ein Wort pro Zeile.',
        custom_words_placeholder: 'Name Ihres Dienstes, Firmenname, etc.',
        password_expiration: 'Passwortablauf',
        password_expiration_description: 'Benutzer müssen ihr Passwort nach einer festgelegten Anzahl von Tagen zurücksetzen. Benutzer, die sich über SSO oder Passkey anmelden, sind nicht betroffen.',
        enable_password_expiration: 'Passwortablauf aktivieren',
        enable_password_expiration_description: 'Benutzer müssen ihr Passwort regelmäßig zurücksetzen. Bestehende Benutzer ohne aufgezeichnetes Datum der Passwortänderung werden ab dem Datum bewertet, an dem diese Richtlinie aktiviert wurde.',
        enable_password_expiration_tip: 'Du kannst den Passwortablauf erst aktivieren, nachdem du in der Anmeldeerfahrung mindestens eine Methode zum Zurücksetzen des Passworts mit einem gültigen Connector konfiguriert hast.',
        expiration_period: 'Passwort-Gültigkeitsdauer (Tage)',
        expiration_period_description: 'Anzahl der Tage, die ein Passwort gültig bleibt, bevor es abläuft.',
        expiration_period_error: 'Die Passwort-Gültigkeitsdauer muss zwischen {{min}} und {{max}} Tagen liegen.',
        password_expiration_recovery_reminder: 'Einige Benutzer haben möglicherweise keine E-Mail-Adresse oder Telefonnummer, um einen Code zur Passwortwiederherstellung zu erhalten, und können daher ein abgelaufenes Passwort nicht zurücksetzen. Verlange bei der Registrierung eine E-Mail-Adresse oder Telefonnummer, damit jeder Benutzer sein Passwort wiederherstellen kann.',
    },
    verification_code_policy: {
        card_title: 'Verifizierungscode',
        card_description: 'Konfigurieren Sie die Ablaufdauer und die maximale Anzahl erneuter Versuche für Verifizierungscodes, die bei Anmeldung, Registrierung und Passwortzurücksetzung verwendet werden.',
        enable: {
            title: 'Verifizierungscode-Einstellungen anpassen',
            description: 'Erlaubt die Anpassung der Ablaufdauer des Verifizierungscodes und der maximalen Anzahl erneuter Versuche.',
        },
        expiration_duration: {
            title: 'Ablaufdauer (Sekunden)',
            description: 'Die Dauer in Sekunden, während der ein Verifizierungscode nach dem Senden gültig bleibt.',
            error_message: 'Die Ablaufdauer muss zwischen 60 und 3600 Sekunden liegen.',
        },
        max_retry_attempts: {
            title: 'Maximale Anzahl erneuter Versuche',
            description: 'Maximale Anzahl fehlgeschlagener Verifizierungsversuche, bevor der Code ungültig wird.',
            error_message: 'Die maximale Anzahl erneuter Versuche muss zwischen 1 und 100 liegen.',
        },
    },
    sentinel_policy: {
        card_title: 'Identifier-Sperre',
        card_description: 'Sperren ist für alle Benutzer mit Standardeinstellungen verfügbar, aber Sie können es anpassen, um mehr Kontrolle zu haben.\n\nSperren Sie einen Bezeichner vorübergehend nach mehreren fehlgeschlagenen Authentifizierungsversuchen (z. B. aufeinanderfolgende falsche Passwörter oder Verifizierungscodes), um Brute-Force-Zugriffe zu verhindern.',
        enable_sentinel_policy: {
            title: 'Sperrerfahrung anpassen',
            description: 'Erlaubt die Anpassung der maximalen fehlgeschlagenen Anmeldeversuche vor der Sperre, der Sperrdauer und der sofortigen manuellen Entsperrung.',
        },
        max_attempts: {
            title: 'Maximale fehlgeschlagene Versuche',
            description: 'Einen Bezeichner vorübergehend sperren, nachdem die maximale Anzahl gescheiterter Anmeldeversuche innerhalb einer Stunde erreicht wurde.',
            error_message: 'Maximale fehlgeschlagene Versuche müssen größer als 0 sein.',
        },
        lockout_duration: {
            title: 'Sperrdauer (Minuten)',
            description: 'Sperren Sie Anmeldungen für eine Zeit, nachdem das Maximum an fehlgeschlagenen Versuchen überschritten wurde.',
            error_message: 'Die Sperrdauer muss mindestens 1 Minute betragen.',
        },
        manual_unlock: {
            title: 'Manuelle Entsperrung',
            description: 'Entsperren Sie Benutzer sofort, indem Sie ihre Identität bestätigen und ihren Bezeichner eingeben.',
            unblock_by_identifiers: 'Über Bezeichner entsperren',
            modal_description_1: 'Ein Bezeichner wurde vorübergehend aufgrund mehrerer fehlgeschlagener Anmelde-/Registrierungsversuche gesperrt. Um die Sicherheit zu schützen, wird der Zugriff nach der Sperrdauer automatisch wiederhergestellt.',
            modal_description_2: ' Entsperren Sie manuell nur, wenn Sie die Identität des Benutzers bestätigt haben und sicherstellen, dass keine unbefugten Zugriffsversuche vorliegen.',
            placeholder: 'Bezeichner eingeben (E-Mail-Adresse / Telefonnummer / Benutzername)',
            confirm_button_text: 'Jetzt entsperren',
            success_toast: 'Erfolgreich entsperrt',
            duplicate_identifier_error: 'Bezeichner bereits hinzugefügt',
            empty_identifier_error: 'Bitte geben Sie mindestens einen Bezeichner ein',
        },
    },
    blocklist: {
        card_title: 'E-Mail-Blockliste',
        card_description: 'Kontrollieren Sie Ihre Benutzerdatenbank, indem Sie risikoreiche oder unerwünschte E-Mail-Adressen blockieren.',
        custom_email_allowlist: {
            title: 'Benutzerdefinierte E-Mail-Adressen zulassen',
            description: 'Fügen Sie Regeln hinzu, um nur bestimmte E-Mail-Domains, E-Mail-Adressen oder Wildcard-Muster für neue Registrierungen und neu verknüpfte E-Mails zuzulassen. Beispiele: bar@example.com, @example.com, foo*@example.com, *@example.com. Die Domains gmail.com und googlemail.com werden als gleichwertig behandelt und Punkte im lokalen Teil werden ignoriert, daher entspricht foo.bar@gmail.com der Adresse foobar@googlemail.com.',
            placeholder: 'E-Mail-Adresse, Domain oder Wildcard-Muster eingeben',
            duplicate_error: 'E-Mail-Adresse, Domain oder Wildcard-E-Mail-Muster wurde bereits hinzugefügt',
            invalid_format_error: 'Muss eine gültige E-Mail-Adresse (bar@example.com), Domain (@example.com) oder ein Wildcard-E-Mail-Muster (foo*@example.com, *@example.com) sein',
            warnings: {
                identical_entries: 'Einige Allowlist-Einträge sind auch in den Blockierregeln vorhanden. Passende E-Mails können weiterhin blockiert werden.',
                blocked_exact_email: 'Einige exakte Allowlist-E-Mails passen zu einer Blockierregel. Passende E-Mails können weiterhin blockiert werden.',
                blocked_subaddressing: 'Einige Allowlist-Einträge enthalten ein Pluszeichen (+), aber E-Mail-Subaddressing ist blockiert.',
                effectively_unusable: 'Basierend auf diesen Prüfungen lässt die aktuelle Allowlist möglicherweise keine neue E-Mail durch.',
            },
        },
        disposable_email: {
            title: 'Blockieren temporärer E-Mail-Adressen',
            description: 'Aktivieren Sie die Ablehnung von Anmeldungsversuchen mit temporären oder Wegwerf-E-Mail-Adressen, um Spam zu verhindern und die Benutzerqualität zu verbessern.',
        },
        email_subaddressing: {
            title: 'Blockieren von E-Mail-Subaddressing',
            description: 'Aktivieren Sie die Ablehnung von Anmeldungsversuchen mit E-Mail-Subadressen, die ein Pluszeichen (+) und zusätzliche Zeichen enthalten (z. B. user+alias@foo.com).',
        },
        custom_email_address: {
            title: 'Benutzerdefinierte E-Mail-Adressen blockieren',
            description: 'Fügen Sie Regeln hinzu, um bestimmte E-Mail-Domains, E-Mail-Adressen oder Wildcard-Muster an der Registrierung oder Verknüpfung über die Benutzeroberfläche zu hindern. Beispiele: bar@example.com, @example.com, foo*@example.com, *@example.com. Die Domains gmail.com und googlemail.com werden als gleichwertig behandelt und Punkte im lokalen Teil werden ignoriert, daher entspricht foo.bar@gmail.com der Adresse foobar@googlemail.com.',
            placeholder: 'E-Mail-Adresse, Domain oder Wildcard-Muster eingeben',
            duplicate_error: 'E-Mail-Adresse, Domain oder E-Mail-Adressmuster mit Platzhalter bereits hinzugefügt',
            invalid_format_error: 'Muss eine gültige E-Mail-Adresse (bar@example.com), Domain (@example.com) oder ein E-Mail-Adressmuster mit Platzhalter (foo*@example.com, *@example.com) sein',
        },
    },
};
export default Object.freeze(security);
